import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import DashboardPage from './pages/DashboardPage';
import ParticipantsPage from './pages/ParticipantsPage';
import UsersPage from './pages/UsersPage';
import RolesPage from './pages/RolesPage';
import AuditPage from './pages/AuditPage';
import CampaignsPage from './pages/CampaignsPage';
import AgentsPage from './pages/AgentsPage';
import ReportsPage from './pages/ReportsPage';
import ProfilePage from './pages/ProfilePage';
import ConstructionPage from './pages/ConstructionPage';
import InactivityMonitor from './components/InactivityMonitor';
import DynamicTitle from './components/DynamicTitle';
import { SoftphoneProvider } from './context/SoftphoneContext';

// Set dayjs locale to Spanish
dayjs.locale('es');

// Protected Route Wrapper
const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <MainLayout /> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <ConfigProvider
      locale={esES}
      theme={{
        token: {
          colorPrimary: '#E60000', // One global source of truth for branding
          borderRadius: 4
        },
        components: {
          Button: {
            fontSizeLG: 14,
            controlHeightLG: 36,
          }
        }
      }}
    >
      <AuthProvider>
        <SoftphoneProvider>
          <Router>
            <DynamicTitle />
            <InactivityMonitor />
            <Routes>
              <Route path="/login" element={<Login />} />

              {/* Protected Routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/participants" element={<ParticipantsPage />} />
                <Route path="/callcenter/campaigns" element={<CampaignsPage />} />
                <Route path="/callcenter/agents" element={<AgentsPage />} />
                <Route path="/system/users" element={<UsersPage />} />
                <Route path="/system/roles" element={<RolesPage />} />
                <Route path="/system/audit" element={<AuditPage />} />
                <Route path="/callcenter/reports" element={<ReportsPage />} />

                {/* WhatsApp Construction Rows */}
                <Route path="/whatsapp/chats" element={<ConstructionPage title="Conversaciones de WhatsApp" />} />
                <Route path="/whatsapp/config" element={<ConstructionPage title="Configuración de WhatsApp" />} />

                {/* Add more routes here as we implement modules */}
                <Route path="*" element={<div>Página no encontrada</div>} />
              </Route>
            </Routes>
          </Router>
        </SoftphoneProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
